import { render } from "./BaseFormT.vue?vue&type=template&id=e02f2c28"
import script from "./BaseFormT.vue?vue&type=script&lang=js"
export * from "./BaseFormT.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__